import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=f17bc7fe&"
import script from "./Slogan.vue?vue&type=script&lang=js&"
export * from "./Slogan.vue?vue&type=script&lang=js&"
import style0 from "./Slogan.vue?vue&type=style&index=0&id=f17bc7fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports